import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ROUTES } from '../../../route/routes';
import { SpinnerService } from 'src/app/_components/spinner/spinner.service';

@Component({
  selector: 'app-pre-landing',
  templateUrl: './pre-landing.component.html',
  styleUrls: ['./pre-landing.component.scss'],
  standalone: false
})
export class PreLandingComponent implements OnInit {

  wrongInput: boolean = false;
  constructor(
    private route: Router,
    private userService: UserService,
    private spinner: SpinnerService
  ) { }

  ngOnInit(): void {
    if (this.userService.token)
      this.route.navigate([ROUTES.HOME.path]);
  }

   login() {
    this.spinner.show();
    this.wrongInput = false;
    this.userService.signInWithPopupFirebase()
        .then((result) => {
          if(result?.user)
            return result.user.getIdToken();
          else // Go to catch error
            throw new Error("Token non presente");
        })
        .then((result2) => {
          this.getInfoUser(result2);
        })
        .catch((error) => {
          console.log(error);
          this.spinner.hide();
          this.wrongInput = true;
        });
  }

  getInfoUser(idToken:string) : void{
    this.spinner.show();

    this.userService.login(idToken).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.userService.setLoginInfo(response,idToken);
        this.route.navigate([ROUTES.HOME.path]);
      },
      error: (err) => {
        console.log(err);
        this.spinner.hide();
        this.wrongInput = true;
        this.spinner.hide();
      },
    });
  }

}
